import createVueComponent from '../createVueComponent';
var Database = createVueComponent('DatabaseIcon', [['ellipse', {
  cx: '12',
  cy: '5',
  rx: '9',
  ry: '3',
  key: 'msslwz'
}], ['path', {
  d: 'M21 12c0 1.66-4 3-9 3s-9-1.34-9-3',
  key: 'pw5pse'
}], ['path', {
  d: 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5',
  key: '7dtpbs'
}]]);
export default Database;